import styled from '@emotion/styled'

export const Wrapper = styled.div`
  padding: 20px 0;
`
